import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";

import Button from "@mui/material/Button";
import SvgIcon from "@mui/material/SvgIcon";
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';

import {LookCartIcon} from "../../common/icons";
import {
  getPriceWithCurrency,
  getQuotePriceWithTaxes,
  getTotalPrice,
  isIframe,
  toFixedPrice
} from "../../../misc/helpers";
// import {showQuoteSavedNotification} from "../../ui/successNotification";
// import {saveQuote} from "../../../api/server-api";
import WithAddToCartPostMessage from "../hocs/withAddToCartPostMessage";
import {cartItemInStock} from "../lookNavigation/lookFunctions2";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../analytics";
import WithOpenMiniCartPostMessage from "../hocs/withOpenMiniCartPostMessage";
import {getCartItemsCount} from "../grohe/groheNavigation/groheFunctions";
import {ROUTES} from "../../../routes";
import {pricingIsLocked} from "../lookNavigation/lookNavigationFunctions";
import {setLookOverlayOpened, setLookPageOpened} from "../../../actions/lookFunctions";
import LookFeaturePriceLocked from "../lookNavigation/lookMain/lookListFeature/lookFeaturePriceLocked";
import {LOOK_OVERLAYS} from "../core/constants";
import {getAnalyticsEcommerceValues} from "../../../analyticsEcommerceParams";


const LookListFooter = (props) => {

  const {discountSections, fabricatorData, cartItems, isMobile, lookPageOpened, visualizersLoadedLength, history,
    setLookPageOpened, isPhoneNumberValidated, showUnlockCalculations, showTotalItems, setLookOverlayOpened,
    intl} = props;
  const fabricatorSettings = fabricatorData.settings;

  const isLixil = isIframe() && fabricatorData.isLixil;
  const withoutCheckout = !isLixil && !fabricatorSettings.checkout;
  const totalPrice = getTotalPrice();
  let grandTotal = getQuotePriceWithTaxes(totalPrice, discountSections);

  const requestQuoteClick = () => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookListRequestQuote);
    setLookOverlayOpened(LOOK_OVERLAYS.leadCapture, "quotation");
  };

  const viewCartClick = (openMiniCartPostMessage) => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookListOpenMiniCart);
    const {currency, value, items} = getAnalyticsEcommerceValues();
    Analytics.sendEcommerceEvent("view_cart", {currency, value, items});
    openMiniCartPostMessage();
  };

  const disabled = cartItems.every(cartItem => !cartItemInStock(cartItem) || cartItem.isRemoved || !cartItem.quantity);

  let itemsToCount = getCartItemsCount(cartItems, intl);
  let {pricingLocked, showPrice} = pricingIsLocked();
  if (!pricingLocked && fabricatorSettings.enableQuote && !isPhoneNumberValidated) {
    pricingLocked = true;
  }
  const hideTotal = (!isLixil && !showPrice) || (showUnlockCalculations && !showTotalItems.includes("total"));
  const hideCheckout = (showUnlockCalculations && !showTotalItems.includes("checkout"));

  const getListFooterButtonText = () => {
    if (fabricatorSettings.enableQuote && !isPhoneNumberValidated) {
      return "leadCapturePopup.getQuote"
    } else if (withoutCheckout) {
      return "leadCapturePopup.saveDesignButton"
    } else if (pricingLocked) {
      return "look.list.footer.addToCartButtonLocked"
    // } else if (fabricatorSettings.checkout && fabricatorSettings.hasPaymentGateway) {
    //   return "buttons.checkout"
    } else {
      return "look.list.footer.addToCartButton" // lixil text
    }
  }

  const checkoutClick = (addToCartPostMessage) => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookListAddToCart);
    if (isLixil || !fabricatorSettings.checkout) {
      addToCartPostMessage();
    } else if (pricingLocked) {
      window.clearTimeout(window.leadCaptureTimeoutId);
      setLookOverlayOpened(LOOK_OVERLAYS.leadCapture);
    } else {
      setLookPageOpened(ROUTES.cart);
      history.push(ROUTES.cart);
    }
    // saveQuote({
    //   submit: true,
    // })
    //   .then((responseData) => {
    //     document.kvConfig.jobId = responseData.jobId;
    //     showQuoteSavedNotification("successNotification.titleQuoteCreated");
    //     setIsLoading(false);
    //   })
    //   .catch(() => {
    //     setIsLoading(false);
    //   })
  };

  return (
    <footer className={"ll-footer" + (isMobile && (lookPageOpened === ROUTES.list && visualizersLoadedLength) ? " ll-footer--opened" : "")}>
      {/*<div className="ll-notification">*/}
      {/*  <FormattedMessage id="look.list.footer.notification"/>*/}
      {/*</div>*/}
      {isMobile && (lookPageOpened !== ROUTES.list) ? null : (
        <div className={"ll-final" + (!isLixil && !fabricatorSettings.checkout ? " ll-final--price-only" : "")}>
          {isMobile || !isLixil ? null : (
            <WithOpenMiniCartPostMessage>
              {(openMiniCartPostMessage) => (
                <Button className={"look-button look-button--secondary ll-final__button"
                  + (isMobile ? " look-button--no-radius" : " look-button--big look-button--large nowrap")}
                  // disabled={!itemsInTheCart.length}
                        onClick={() => viewCartClick(openMiniCartPostMessage)}>
                  {/*<FormattedMessage id="look.list.footer.viewCartButton"/> ({cItemsAddedToParentCart.length})*/}
                  <FormattedMessage id="look.list.footer.viewCartButton"/>
                </Button>
              )}
            </WithOpenMiniCartPostMessage>
          )}
          <WithAddToCartPostMessage>
            {(addToCartPostMessage) => hideCheckout ? null : (
              <Button className={"look-button look-button--primary ll-final__button"
                + (isMobile ? " look-button--no-radius" : " look-button--big look-button--large nowrap")}
                      disabled={disabled}
                      startIcon={withoutCheckout ? null : <SvgIcon><LookCartIcon /></SvgIcon>}
                      onClick={() => checkoutClick(addToCartPostMessage)}>
                <FormattedMessage id={getListFooterButtonText()}/> {pricingLocked || withoutCheckout ? null : "(" + itemsToCount + ")"}
              </Button>
            )}
          </WithAddToCartPostMessage>
          {fabricatorSettings.callForPricing ? (
            <Button className={"look-button look-button--primary ll-final__button"
              + (isMobile ? " look-button--no-radius" : " look-button--big look-button--large nowrap")}
              // disabled={!itemsInTheCart.length}
                    disabled={disabled}
                    startIcon={<RequestQuoteOutlinedIcon/>}
                    onClick={requestQuoteClick}>
              <FormattedMessage id="look.list.footer.requestQuote"/>
            </Button>
          ) : null}
          {hideTotal ? null : (
            <div className={"ll-final__price" + (pricingLocked ? " ll-final__price--locked" : "")}>
              <span className="ll-final__price-sub-total">
                <FormattedMessage id="look.list.footer.subTotal"/>
              </span>
              <span className={"ll-final__price-sum" + (pricingLocked ? " ll-final__price-sum--locked" : "")}>
                {pricingLocked ? <LookFeaturePriceLocked/> : getPriceWithCurrency(fabricatorSettings, toFixedPrice(grandTotal), true)}
              </span>
            </div>
          )}
        </div>
      )}
    </footer>
  )
};

const mapStateToProps = (store) => {
  const fabricatorData = store.fabricatorState;
  const {discountSections} = store.priceWorksheetState;
  const {cartItems, cItemsAddedToParentCart, sureTax} = store.cartState;
  const {isMobile, visualizersLoaded} = store.serverState;
  const {lookPageOpened} = store.lookState;
  const {isPhoneNumberValidated} = store.userState; // to update component when user is logged in
  const {showUnlockCalculations, showTotalItems} = store.unlockCalculationsState;

  return {
    fabricatorData,
    discountSections,
    cartItems,
    cItemsAddedToParentCart,
    isMobile,
    lookPageOpened,
    visualizersLoadedLength: visualizersLoaded.length,
    isPhoneNumberValidated,
    sureTax, // to update when response received
    showUnlockCalculations,
    showTotalItems
  };
};

const mapDispatchToProps = {
  setLookPageOpened,
  setLookOverlayOpened,
};

export default injectIntl(
  withRouter(
    connect(mapStateToProps, mapDispatchToProps)(LookListFooter)
  )
)
